<template>
  <v-card>
    <v-card-title class="text-headline-small bg-grey-lighten-2" primary-title>
      Suppression d'un assemblage
    </v-card-title>
    <v-card-text>{{ message }}</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="text" @click="cancel">Annuler</v-btn>
      <v-btn color="primary" variant="text" @click="confirm">Supprimer</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { DialogPropsMixin } from '@/components/dialog/mixins';
import { RemoveComposite } from '@/_services/jobs';
import { stepperMixin } from '@/classes/helper/stepperHelper';

export default {
  name: 'CompositeDeleteDialog',
  mixins: [DialogPropsMixin, stepperMixin],
  computed: {
    message() {
      const suffix = this.payload.name !== this.payload.composite.name ? ` ${this.payload.composite.name} ` : '';

      return `Voulez vous vraiment supprimer l'assemblage ${this.payload.name}${suffix}?`;
    },
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('loading');
      RemoveComposite(this.$store.getters['submission/getJobId'], this.payload.composite.compositePrototypeId)
        .then(() => {
          this.$store.dispatch('job/destroyComposite', {
            compositeId: this.payload.composite.id,
            phaseId: this.payload.phaseId,
          });
        })
        .finally(() => {
          this.updateTotalCost(this.$store.getters['submission/getJobId'])
            .catch(error => {
              this.$store.dispatch('snackbar/set', error);
            })
            .finally(() => {
              this.$emit('loading', false);
              this.$emit('close');
            });
        });
    },
  },
};
</script>
